module.exports = __webpack_public_path__ + "static/img/D001.1006a36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/D001.jpg
// module id = ltIh
// module chunks = 1